import Vue from 'vue'
import $api from '@/api/index'
// 基本模块
const baseModule = {
  state: {
    isLoading: false,
    commonLoading: 9,
    token: '',
    userInfo: null,
    uploadSys: '', // 上传下载key
    uploadTime: 0,
    dictionary: {},
    dictionaryLabel: {},
    cityList: [], // 三级城市列表
    cityList2: [], // 二级城市列表
    industry: [],
    industryLabel: {}, // 行业二级
    specialty: [],
    specialtyLabel: {}, // 专业label
    functionTree: [], // 职能
    functionLabel: {},
    positionTree: [], // 职位
    positionLabel: {},
    soldierTree: [], // 军人
    soldierLabel: {},
    skillTree: [], // 技能
    skillLabel: {}
  },
  mutations: {
    setLoading: (state, data) => {
      state.isLoading = data
    },
    setToken: (state, data) => {
      state.userInfo = null // 清空用户信息
      state.token = data
    },
    removeToken: (state) => {
      state.token = null
    },
    setUserInfo: (state, data) => {
      state.userInfo = data
    },
    setUploadSys: (state, data) => {
      state.uploadSys = data
      state.uploadTime = Date.now()
    },
    setDictionary: (state, data) => {
      for (let j in data) {
        Vue.set(state.dictionary, j, data[j])
        let json = {}
        data[j].forEach(o => {
          json[o['itemValue']] = o['itemName']
        })
        Vue.set(state.dictionaryLabel, j, json)
      }
    },
    setRegion: (state, data) => {
      state.cityList = data
      let nCity = []
      data.forEach((o) => {
        let nJson = {id: o.id, name: o.name}
        let nChild = []
        if (o.children && o.children.length > 0) {
          o.children.forEach((co) => {
            nChild.push({id: co.id, name: co.name})
          })
        }
        nJson['children'] = nChild
        nCity.push(nJson)
      })
      state.cityList2 = nCity
    },
    setIndustry: (state, data) => {
      data.forEach(o => {
        o.disabled = false
        o.children.forEach(m => {
          m.disabled = false
        })
      })
      state.industry = data
      data.forEach(o => {
        let child = o['children']
        if (child) {
          child.forEach(k => {
            Vue.set(state.industryLabel, k['pid'] + '_' + k['id'], k['name'])
          })
        } else {
          Vue.set(state.industryLabel, o['id'], o['name'])
        }
      })
    },
    setSpecialty: (state, data) => {
      state.specialty = data
      data.forEach(o => {
        let child = o['children']
        if (child) {
          child.forEach(j => {
            let pid = j['pid']
            let sChild = j['children']
            if (sChild) {
              sChild.forEach(k => {
                Vue.set(state.specialtyLabel, pid + '_' + k['pid'] + '_' + k['id'], k['name'])
              })
            } else {
              Vue.set(state.specialtyLabel, pid + '_' + j['id'], j['name'])
            }
          })
        } else {
          Vue.set(state.specialtyLabel, o['id'], o['name'])
        }
      })
    },
    setFunction: (state, data) => {
      state.functionTree = data
      data.forEach(o => {
        let child = o['children']
        if (child) {
          child.forEach(j => {
            if (j['children']) {
              let fChild = j['children']
              let pid = j['pid']
              fChild.forEach(k => {
                Vue.set(state.functionLabel, pid + '_' + k['pid'] + '_' + k['id'], k['name'])
              })
            } else {
              Vue.set(state.functionLabel, j['pid'] + '_' + j['id'], j['name'])
            }
          })
        } else {
          Vue.set(state.functionLabel, o['id'], o['name'])
        }
      })
    },
    setMilitary: (state, data) => {
      state.soldierTree = data
      data.forEach(o => {
        let child = o['children']
        if (child) {
          child.forEach(j => {
            if (j['children']) {
              let fChild = j['children']
              let pid = j['pid']
              fChild.forEach(k => {
                Vue.set(state.soldierLabel, pid + '_' + k['pid'] + '_' + k['id'], k['name'])
              })
            } else {
              Vue.set(state.soldierLabel, j['pid'] + '_' + j['id'], j['name'])
            }
          })
        } else {
          Vue.set(state.soldierLabel, o['id'], o['name'])
        }
      })
    },
    setPosition: (state, data) => {
      state.positionTree = data
      data.forEach(o => {
        let child = o['children']
        if (child) {
          child.forEach(j => {
            let pChild = j['children']
            let pid = j['pid']
            if (pChild) {
              pChild.forEach(k => {
                Vue.set(state.positionLabel, pid + '_' + k['pid'] + '_' + k['id'], k['name'])
              })
            } else {
              Vue.set(state.positionLabel, j['pid'] + '_' + j['id'], j['name'])
            }
          })
        } else {
          Vue.set(state.positionLabel, o['id'], o['name'])
        }
      })
    },
    setSkill: (state, data) => {
      state.skillTree = data
    },
    setCommonLoading: (state, data) => {
      if (data === 9) {
        state.commonLoading = data
      } else {
        state.commonLoading--
      }
    }
  },
  actions: {
    getUserInfo: ({commit}) => {
      return new Promise((resolve) => {
        $api.loginInfo(res => {
          commit('setUserInfo', res)
          resolve(res)
        }, () => {
          setTimeout(() => {
            commit('setLoading', false)
          }, 500)
        }, () => {
          commit('removeToken')
          resolve('err')
        })
      })
    },
    getUploadInfo: ({commit}) => {
      $api.getCosKey(res => {
        commit('setUploadSys', res)
        commit('setCommonLoading', 1)
      })
    },
    getDictionary: ({commit}) => {
      $api.getDictionary(res => {
        commit('setDictionary', res)
        commit('setCommonLoading', 1)
      })
    },
    getRegion: ({commit}) => {
      $api.getRegion(res => {
        commit('setRegion', res)
        commit('setCommonLoading', 1)
      })
    },
    getIndustry: ({commit}) => {
      $api.getIndustry(res => {
        commit('setIndustry', res)
        commit('setCommonLoading', 1)
      })
    },
    getSpecialty: ({commit}) => {
      $api.getSpecialty(res => {
        commit('setSpecialty', res)
        commit('setCommonLoading', 1)
      })
    },
    getFunction: ({commit}) => {
      $api.getFunction(res => {
        commit('setFunction', res)
        commit('setCommonLoading', 1)
      })
    },
    getMilitary: ({commit}) => {
      $api.getMilitary(res => {
        commit('setMilitary', res)
        commit('setCommonLoading', 1)
      })
    },
    getPosition: ({commit}) => {
      $api.getPositionTree(res => {
        commit('setPosition', res)
        commit('setCommonLoading', 1)
      })
    },
    getSkill: ({commit}) => {
      $api.getSkill(res => {
        commit('setSkill', res)
        commit('setCommonLoading', 1)
      })
    }
  }
}

export default baseModule



// WEBPACK FOOTER //
// ./src/store/base.js